import 'promise-polyfill/src/polyfill';
import 'whatwg-fetch';
import 'abortcontroller-polyfill';
import Vue from 'vue';
import HomepageOffers from './HomepageOffers.vue';

Vue.config.productionTip = false;

new Vue({
  render: h => h(HomepageOffers),
}).$mount('.homepage-offers-vue');
